import { createContext } from 'react';
import type { ProviderLimitedDetail } from '../../api';

export const ProviderLimitContext = createContext<{
  providerLimit: ProviderLimitedDetail | null;
  setProviderLimit?: (providerLimit: ProviderLimitedDetail) => void;
}>({
  providerLimit: null,
  setProviderLimit: () => {},
});
